import { Injectable } from '@angular/core';
import {
  collection,
  collectionData,
  CollectionReference,
  deleteDoc,
  doc,
  DocumentData,
  Firestore,
  increment,
  limit,
  query,
  QueryConstraint,
  QueryDocumentSnapshot,
  serverTimestamp,
  setDoc,
  SnapshotOptions,
  updateDoc,
  where,
  WithFieldValue,
} from '@angular/fire/firestore';
import { toDate } from 'lib/src/public-api';
import { Observable } from 'rxjs';
import { StoredFile } from '../file.model';

type Model = StoredFile;

@Injectable({
  providedIn: 'root'
})
export class FileDbService {
  public collection: CollectionReference<any>;
  constructor(private firestore: Firestore) {}

  createId() {
    return doc(collection(this.firestore, 'id')).id;
  }

  create(id, data, collectionPath) {
    data.updatedAt = serverTimestamp();
    data.createdAt = serverTimestamp();
    data._version = increment(1);
    data.id = id;
    return setDoc(doc(this.firestore, collectionPath, id), data);
  }

  delete(file, collectionPath) {
    return deleteDoc(doc(this.firestore, collectionPath, file.id));
  }

  update(file, collectionPath){
    const id = file.id;
    return updateDoc(doc(this.firestore, collectionPath, id), file);
  }

  getAll$(collectionPath): Observable<Model[]> {
    const _collection = collection(
      this.firestore,
      collectionPath
    ).withConverter(this.genericConverter);
    const _query = query(_collection, limit(100));
    return collectionData(_query, { idField: 'id' }) as Observable<Model[]>;
  }  


  getByRef$(collectionPath, _ref, type):Observable<any[]>{
    const _collection = collection(this.firestore, collectionPath).withConverter(this.genericConverter);
    let _where: QueryConstraint[] = [];
    _where.push(where('ref', '==', _ref));
    _where.push(where('type', '==', type));
    const _query = query(_collection, ..._where);
    return collectionData(_query, { idField: 'id' })    
  }

  normalize(data){
    data.createdAt = toDate(data.createdAt);
    data.updatedAt = toDate(data.updatedAt);
    return data;
  }

  genericConverter = {
    toFirestore(data: WithFieldValue<Model>): DocumentData {
      return data as DocumentData;
    },
    fromFirestore(
      snapshot: QueryDocumentSnapshot,
      options: SnapshotOptions
    ): Model {
      const data = snapshot.data(options)!;
      data['createdAt'] = toDate(data['createdAt']);
      data['updatedAt'] = toDate(data['updatedAt']);
      return data as Model;
    },
  };
}
